export const ACCREDITATIONINFO_LOAD = 'ACCREDITATIONINFO_LOAD';
export const ACCREDITATIONINFO_UPDATE = 'ACCREDITATIONINFO_UPDATE';
export const ACCREDITATIONINFO_CREATE = 'ACCREDITATIONINFO_CREATE';
export const ACCREDITATIONINFO_REMOVE = 'ACCREDITATIONINFO_REMOVE';
export const ACCREDITATIONINFO_OPEN = 'ACCREDITATIONINFO_OPEN';
export const ACCREDITATIONINFO_SAVE_ATTEMPT = 'ACCREDITATIONINFO_SAVE_ATTEMPT';
export const ACCREDITATIONINFO_SAVE = 'ACCREDITATIONINFO_SAVE';
export const ACCREDITATIONINFO_ORGANIZATIONS_LOAD = 'ACCREDITATIONINFO_ORGANIZATIONS_LOAD';

export const loadAccreditationInfo = (catalogItem) => async (dispatch, getState) => {
    const {oidc, minervaSettings} = getState();
    const {portalIdentifier, apiUrl, accreditationEnabled} = minervaSettings;
    const {targetId} = catalogItem;

    if (!accreditationEnabled) {
        return;
    }

    return dispatch({
        type: ACCREDITATIONINFO_LOAD,
        async payload() {
            const data = await fetchJson(
                `${apiUrl}/api/1.0/accreditationinfo/${portalIdentifier}/${targetId}`,
                oidc,
            );

            if (!data?.accreditations) {
                return {};
            }

            return {
                accreditations: data.globalAccreditations
                    ? data.accreditations.concat(
                          data.globalAccreditations.map((a) => ({...a, global: true})),
                      )
                    : data.accreditations,
                suppliers: data.suppliers.map((s) => ({
                    value: s,
                    label: s,
                })),
                organizations: data.organizations.map((o) => ({
                    value: o.key,
                    label: o.key,
                    excluded: o.isExcludedFromProcessing,
                })),
            };
        },
    });
};

export const updateAccreditationMapping = (index, changes) => (dispatch) => {
    dispatch({
        type: ACCREDITATIONINFO_UPDATE,
        payload: {
            index: index,
            changes: changes,
        },
    });
};

export const createAccreditationMapping = () => (dispatch, getState) => {
    const state = getState();

    dispatch({
        type: ACCREDITATIONINFO_CREATE,
        payload: {
            supplierKey: state.accreditationInfo.suppliers[0].value,
            organizationKey: state.accreditationInfo.organizations[0].value,
            data: {},
        },
    });
};

export const removeAccreditationMapping = (index) => (dispatch) => {
    dispatch({
        type: ACCREDITATIONINFO_REMOVE,
        payload: {
            index: index,
        },
    });
};

// After a save attempt the mappings added so far are no longer new, so they are marked when invalid.
export const markAccreditationSaveAttempt = () => (dispatch) => {
    dispatch({type: ACCREDITATIONINFO_SAVE_ATTEMPT});
};

export const openAccreditationMapping = (index, value) => (dispatch) => {
    dispatch({
        type: ACCREDITATIONINFO_OPEN,
        payload: {
            index: index,
            value: value,
        },
    });
};

export const saveAccreditationInfo = (catalogItem) => async (dispatch, getState) => {
    const {oidc, minervaSettings, accreditationInfo} = getState();
    const {portalIdentifier, apiUrl} = minervaSettings;
    const {targetId} = catalogItem;

    dispatch({
        type: ACCREDITATIONINFO_SAVE,
        async payload() {
            const res = await fetch(
                `${apiUrl}/api/1.0/accreditationinfo/${portalIdentifier}/${targetId}`,
                {
                    method: 'POST',
                    // The GLOBAL mappings are set by SDB and are not part of the portal's settings.
                    body: JSON.stringify(accreditationInfo.current.filter((a) => !a.global)),
                    headers: {
                        'Content-Type': 'application/json',
                        ...getAuthorizationHeaders(oidc.user),
                    },
                },
            );

            ensureResponseStatus(res);

            return {};
        },
    });
};

export const loadOrganizations = () => async (dispatch, getState) => {
    const {oidc, minervaSettings, accreditationInfo} = getState();
    const {apiUrl, accreditationEnabled} = minervaSettings;

    if (!accreditationEnabled) {
        return;
    }

    dispatch({
        type: ACCREDITATIONINFO_ORGANIZATIONS_LOAD,
        async payload() {
            if (accreditationInfo.organizations != null) {
                return accreditationInfo.organizations;
            }
            const organizations = await fetchJson(
                `${apiUrl}/api/1.0/accreditationinfo/organizations`,
                oidc,
            );

            return organizations.map((o) => ({
                value: o.key,
                label: o.key,
                excluded: o.isExcludedFromProcessing,
            }));
        },
    });
};

export const ensureResponseStatus = (res, acceptStatusCodes) => {
    if (res.status < 200 || res.status >= 400) {
        if (acceptStatusCodes && acceptStatusCodes.find((code) => code === res.status)) {
            return;
        }

        throw new Error(`Http error occurred (${res.status})`);
    }
};

const fetchJson = async (url, oidc) => {
    const res = await fetch(url, {
        headers: getAuthorizationHeaders(oidc.user),
    });

    ensureResponseStatus(res, [404]);

    if (res.status === 404) {
        return {};
    }

    return await res.json();
};

const getAuthorizationHeaders = (user) => {
    return user ? {Authorization: `Bearer ${user.access_token}`} : {};
};
